import { useAdminState } from "../Context"
import { AdminPagination } from "components/partials"

const Pagination = () => {
  const { rows, params, isLoading } = useAdminState()
  const { pagination } = params

  if (isLoading) return null
  if (pagination === null) return null

  return <AdminPagination rows={rows} pagination={pagination} />
}

export default Pagination
